export const getFacebookShareLink = (othShareLink) => {
  return `https://www.facebook.com/sharer/sharer.php?u=${othShareLink}`;
};

export const getTwitterShareLink = (propertyAddress, othShareLink) => {
  return `https://twitter.com/intent/tweet?text=${propertyAddress} found at ${othShareLink}`;
};

export const getEmailShareLink = (propertyAddress, isFromCollection, othShareLink) => {
  return `mailto:?subject=${propertyAddress} - Onthehouse.com.au&body=I would like to share this ${isFromCollection ? 'collection' : 'property'} from onthehouse.com.au with you: ${othShareLink}`;
};

export const isOnMobileDevice = (navigator) => {
  return /Android|iPhone|iPad/i.test(navigator.userAgent);
};
